import { getJwtTokenFromCookie, parseJwt } from "@/helpers";

export const isBetaTester = () => {
	const roles = parseJwt(getJwtTokenFromCookie() || "").roles || [];
	return roles.includes("ROLE_BETA_TESTER");
};
